import {FormEvent, useState} from 'react'
import axios from 'axios'
import {useIntl} from 'react-intl'
import {useAuth} from '../modules/auth'
import {useLang} from '../../_metronic/i18n/Metronici18n'
import {API_URL} from '../tenant/apiBase'

const FeedbackPage = () => {
  const {formatMessage} = useIntl()
  const {currentUser} = useAuth()
  const language = useLang()
  const [type, setType] = useState('')
  const [details, setDetails] = useState('')
  const [sending, setSending] = useState(false)
  const [status, setStatus] = useState<'success' | 'error' | 'too_soon' | null>(null)

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!type || !details.trim() || sending) return

    setSending(true)
    setStatus(null)
    try {
      const response = await axios.post(
        `${API_URL}/api/partner-portal/supplier/feedback`,
        {type, details: details.trim(), source: 'website'},
        {headers: {token: currentUser?.token || '', language}}
      )
      // A 401 resolves with nothing while the interceptor redirects to /auth: keep the text.
      if (!response) return
      setType('')
      setDetails('')
      setStatus('success')
    } catch (error) {
      setStatus(axios.isAxiosError(error) && error.response?.status === 429 ? 'too_soon' : 'error')
    } finally {
      setSending(false)
    }
  }

  return (
    <div className='container py-10'>
      <div className='card mx-auto' style={{maxWidth: 640}}>
        <div className='card-body p-8'>
          <h1 className='fs-2 fw-bold mb-6'>{formatMessage({id: 'FEEDBACK.SHARE'})}</h1>
          {status && (
            <div
              role='alert'
              className={`alert alert-${status === 'success' ? 'success' : 'danger'}`}
            >
              {formatMessage({
                id: {
                  success: 'FEEDBACK.SUCCESS',
                  error: 'FEEDBACK.ERROR',
                  too_soon: 'FEEDBACK.TOO_SOON',
                }[status],
              })}
            </div>
          )}
          <form onSubmit={submit}>
            <label htmlFor='feedback-type' className='form-label required'>
              {formatMessage({id: 'FEEDBACK.TYPE'})}
            </label>
            <select
              id='feedback-type'
              className='form-select mb-6'
              value={type}
              onChange={(event) => setType(event.target.value)}
              required
            >
              <option value=''>{formatMessage({id: 'FEEDBACK.SELECT_TYPE'})}</option>
              <option value='note'>{formatMessage({id: 'FEEDBACK.NOTE'})}</option>
              <option value='improvement'>{formatMessage({id: 'FEEDBACK.IMPROVEMENT'})}</option>
              <option value='technical'>{formatMessage({id: 'FEEDBACK.TECHNICAL'})}</option>
            </select>

            <label htmlFor='feedback-details' className='form-label required'>
              {formatMessage({id: 'FEEDBACK.DETAILS'})}
            </label>
            <textarea
              id='feedback-details'
              className='form-control mb-6'
              rows={6}
              maxLength={5000}
              placeholder={formatMessage({id: 'FEEDBACK.DETAILS_HINT'})}
              value={details}
              onChange={(event) => setDetails(event.target.value)}
              required
            />
            <button
              className='btn btn-primary'
              type='submit'
              disabled={sending || !type || !details.trim()}
            >
              {formatMessage({id: sending ? 'FEEDBACK.SENDING' : 'FEEDBACK.SUBMIT'})}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default FeedbackPage
